module.exports = __webpack_public_path__ + "img/eagle.886a6d20.png";